import Header from "./Header";
import Footer from "./Footer";

function Facilities() {
  return (
    <>
      <Header />
      <section className="container my-5 text-primary-emphasis text-center">
        <h2 className="section-title">State-of-the-Art Equipment</h2>
        <p className="col-md-12 col-lg-12 m-auto container">
          Our lab is equipped with modern diagnostic machines that ensure fast,
          accurate, and reliable test results. We provide comprehensive services
          ranging from cardiovascolar health to Haematology, all handled by
          experienced professionals.
        </p>
      </section>

      {/* <!-- Section: Facility Images --> */}
      <section className="container mb-5 text-primary-emphasis text-center">
        <div>
          {" "}
          <h1 class="display-5">Our Medical Laboratory Facilities</h1>
          <p class="lead">Where technology meets care</p>
        </div>
        <div className="row g-4">
          <div className="col-md-4">
            <img
              src="images/assets/haematology.jpg"
              alt="Hematology Equipment"
              className="img-fluid facility-img rounded-4"
              style={{
                maxWidth: "500px",
                maxHeight: "300px",
              }}
            />
            <h5 className="mt-3">Advanced Haematology</h5>
            <p className="text-muted">
              Fast blood analysis with fully automated machines.
            </p>
          </div>
          <div className="col-md-4 col-sm-12 pt-4">
            <img
              src="images/assets/heart.jpg"
              alt="Microbiology Lab"
              className="img-fluid facility-img rounded-4"
              style={{ maxWidth: "400px", maxHeight: "400px" }}
            />
            <h5 className="mt-3">Cardiovascular Health</h5>
            <p className="text-muted">
              Cardiovascular health is essential for a strong heart, efficient
              blood circulation, and overall well-being.
            </p>
          </div>
          <div className="col-md-4 col-sm-12">
            <img
              src="images/assets/molecular.jpg"
              alt="Molecular Diagnostics"
              className="img-fluid facility-img rounded-4"
              style={{ maxWidth: "400px", maxHeight: "400px" }}
            />
            <h5 className="mt-3">Molecular Diagnostics</h5>
            <p className="text-muted">High-precision and Analysis tool.</p>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Facilities;
